import { SETTINGS, CONTENT_TYPE_ID, TAXONOMY_FILTERS, ORDERBY_FIELDS, CHECKBOX_FILTERS, apiPrefix, SYNONYMS } from '../../config';
import { client, cachedSearch, Query, Op, versionStatus, OrderBy } from './client';
import * as queries from './queries';
import { buildExpressions } from '../../expressions';


export async function getEntries(search = {}, settings) {
	let query = new Query(...buildExpressions({ search, settings }));
	query.pageIndex = search.pageIndex || 0;
	query.pageSize = search.pageSize || settings.pageSize;
	if (settings.orderBy) {
		query = await addOrderByQueries(settings.orderBy, query);
	}
	if(search.sort){
		query.orderBy = await queries.sortOrder(search);
	}
	let entries = await cachedSearch.search(query);
	//entries.pageItems = await resolveEntryPaths(entries.pageItems);
	return entries;
}

async function addOrderByQueries(orderBySettings, query) {
	let orderQuery;
	let orderByQueries = Object.keys(orderBySettings)
	.map((_, index) => orderQuery = queries.orderBy(orderBySettings[index].name, orderBySettings[index].direction, orderQuery));
	if (orderQuery) {
		query.orderBy = orderQuery;
	}	
	return query;
}

async function resolveEntryPaths(items) {
	let entryData = items.map((entry) => { return { pageName: entry.pageName ? entry.pageName : entry.commonEntryFields.pageName, contentTypeId: entry.sys.contentTypeId, language: entry.sys.language }; });
	let response = await fetch(`${'/api/custom/routing/resolvepaths/'}`, {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({entries:  entryData})
	});
	let json = await response.json();
	let paths = await json.paths;
	return items.map((entry, index) => { 
			if (entry.sys.dataFormat == "entry") {
				entry.sys.uri = paths[index]
			}
			return entry;
		});
}

function OrderQuery(query) {
	let orderQuery;
	let orderByQueries = Object.keys(ORDERBY_FIELDS)
	.map((_, index) => orderQuery = queries.orderBy(ORDERBY_FIELDS[index].name, ORDERBY_FIELDS[index].direction, orderQuery));
	return orderQuery;
}

export async function FilterCollectionAsync(items, pageIndex) {
	let startIndex = parseInt(pageIndex) * 10;
	let endIndex = parseInt(startIndex) + 10;
	return items.filter((_, index) => index >= startIndex && index < endIndex);
}

export function FilterCollection(items, pageIndex) {
	pageIndex = pageIndex == null ? 0 : pageIndex;
	let startIndex = pageIndex * 10;
	let endIndex = startIndex + 10;
	return items.filter((_, index) => index >= startIndex && index < endIndex);
}

export async function getFilters(settings) {
	let contentType = await cachedSearch.getContentType(settings.contentTypeId);
	return { taxonomyFilters: await getTaxonomyFilters(contentType, settings.taxonomyFilters), checkBoxFilters: getCheckboxes(contentType, settings.checkBoxFilters), textFilters: getTextFilters(contentType, settings.textFilters), taxonomyPathFilters: await getTaxonomyFiltersByPath(settings.taxonomyFilterPaths), listFilters: await getListItems(contentType, settings.listFilters) };
}

async function getTaxonomyFilters(contentType, taxonomyFilters) {
	if (taxonomyFilters) {
		let taxonomyFields = contentType.fields.filter(function (field) {
				return taxonomyFilters.indexOf(field.id) > -1;
			});
		// Handle fetching multiple taxonomy filters from categoryPicker component
		taxonomyFields = taxonomyFields[0].id === 'categoryPicker' ? taxonomyFields[0].fields : taxonomyFields;

		let taxonomyPromises = taxonomyFields.map(field => {
			let taxonomyKey = (field && field.validations && field.validations.taxonomyRoot && field.validations.taxonomyRoot.key);
			return !!taxonomyKey ?
				cachedSearch.getTaxonomyNode(taxonomyKey).then(node => ({
					[field.id]: node
				})) :
				null;
		});
		let filters = await Promise.all(taxonomyPromises);
		return filters.reduce((result, filter) => ({ ...result, ...filter}), {});
	}

	return null;
}

async function getTaxonomyFiltersByPath(taxonomyPaths) {
	if (taxonomyPaths) {
		let taxonomyPromises = taxonomyPaths.map(path => cachedSearch.getTaxonomyNodeByPath(path, 'alphabetical').then(node => ({ [node.name]: node})));
		let filters = await Promise.all(taxonomyPromises);
		return filters.reduce((result, filter) => ({ ...result,
			...filter
		}), {});
	}
}

function getCheckboxes(contentType, checkBoxFilters) {
	if (checkBoxFilters) {
		return contentType.fields.filter(field => checkBoxFilters.indexOf(field.id) > -1).map(function(a) { return { id: a.id, name: a.name['en-GB'], value: true }; });
	}	
}

function getListItems(contentType, listFilters) {
	if (listFilters) { 
		return contentType.fields.filter(field => listFilters.indexOf(field.id) > -1).map(function(m){ 
			return { id: m.id, children:
			m.validations.allowedValues.values.map(function(a) { 
				return { id: a['en-GB'].replace(/\s/g,''), name: a['en-GB'], value: true }; 
			}
		)
		};
	}
	);
	}	
}

function getTextFilters(contentType, textFilters) {
	if (textFilters) {
		return textFilters;
	}	
}

export async function getTaxonomyByFieldName(fieldName)
{	
	let contentType = await cachedSearch.getContentType(CONTENT_TYPE_ID);
	let taxonomyField = contentType.fields.find(field => field.id === fieldName);
	let taxonomyKey = (taxonomyField && taxonomyField.validations && taxonomyField.validations.taxonomyRoot && taxonomyField.validations.taxonomyRoot.key);
	return !!taxonomyKey ?
			cachedSearch.getTaxonomyNode(taxonomyKey).then(node => ({
				[taxonomyField.id]: node,
			})) :
			null;
}

export async function GetSynonyms(){
	return fetch(SYNONYMS).then(r => r.json())
	.then(data => data)
	.catch(e => console.log("Cant load JSON file"))
}